// extracted by mini-css-extract-plugin
export default {"listWrapper":"FilesList_listWrapper__mfSLJ","item":"FilesList_item__p3xlN","mask":"FilesList_mask__0SymC","name":"FilesList_name__dXFWR"};